import { useEffect, useState } from 'react'
import { searchLocations, type LocationInfo } from '../lib/locationMapping'

export interface LocationSuggestion extends LocationInfo {
    jobCount?: number
}

export function useLocationSearch(query: string) {
    const [suggestions, setSuggestions] = useState<LocationSuggestion[]>([])
    const [loading, setLoading] = useState(false)

    // Search locations when query changes
    useEffect(() => {
        if (!query || query.length < 2) {
            setSuggestions([])
            setLoading(false)
            return
        }

        setLoading(true)

        // Use the new searchLocations function which includes coordinates
        const results = searchLocations(query, 5) // Limit to 5 top suggestions

        // Convert to LocationSuggestion (already has coordinates from searchLocations)
        const locationSuggestions: LocationSuggestion[] = results.map(location => ({
            ...location,
            // jobCount could be added later if we want to show how many jobs exist in each location
        }))

        setSuggestions(locationSuggestions)
        setLoading(false)
    }, [query])

    return { suggestions, loading }
}
